import { useCallback, useEffect, useState } from "react";
import NetworkApi from "../network/networkApi";
interface ContentData {
  result: any[];
  loading: boolean;
}
const useUserPlantWarehouse = (): [ContentData, () => void, any] => {
  const [filter, changeFilter] = useState<{
    type?: string;
    ownerId?: string;
    farmlandId?: string;
  }>({});
  const [content, changeContent] = useState<ContentData>({
    loading: false,
    result: [],
  });
  useEffect(() => {
    if (filter.type || filter.ownerId || filter.farmlandId) {
      loadContent();
    }
  }, [filter]);
  const loadContent = useCallback(async () => {
    changeContent({
      ...content,
      loading: true,
    });
    let response = await NetworkApi.requestGet(
      "/api/warehouse/user/plant/list",
      filter
    );
    changeContent({
      loading: false,
      result: response.result?.rows || [],
    });
  }, [content, filter]);

  return [content, loadContent, changeFilter];
};
export default useUserPlantWarehouse;
